import FormattedMessage from 'I18n/components/FormattedMessage';
import { useCallback, useEffect, useMemo } from 'react';
import HubSpotAppLink from '../common/components/HubSpotAppLink';
import { pageFromUrl } from './internal/pageFromUrl';
import PageReturnLinkHelper from './internal/PageReturnLinkHelper';
import I18n from 'I18n';
import { BackButton } from 'foundations-components/transitional/components/BackButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function PageReturnLink({
  fallbackPageName,
  fallbackPagePath,
  LinkComponent,
  onTrackClick
}) {
  const eschref = PageReturnLinkHelper.get();
  const path = eschref || fallbackPagePath;
  useEffect(() => {
    PageReturnLinkHelper.addToSessionStorage();

    // Attempts to clean up after itself if a user navigates away from the record page
    window.addEventListener('pagehide', PageReturnLinkHelper.clear);
    return () => {
      window.removeEventListener('pagehide', PageReturnLinkHelper.clear);
    };
  }, []);
  const pageUrlItem = useMemo(() => {
    return eschref ? pageFromUrl(eschref) : undefined;
  }, [eschref]);
  const {
    ariaLabel,
    backMessage
  } = useMemo(() => {
    if (pageUrlItem) {
      return {
        ariaLabel: I18n.text('crm-links.backToPageName.variable', {
          pageName: I18n.text(pageUrlItem.langKey)
        }),
        backMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: pageUrlItem.langKey
        })
      };
    } else if (eschref || !fallbackPageName) {
      return {
        ariaLabel: I18n.text('crm-links.backToPageName.back'),
        backMessage: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "crm-links.backToPageName.back"
        })
      };
    }
    return {
      ariaLabel: I18n.text('crm-links.backToPageName.variable', {
        pageName: fallbackPageName
      }),
      backMessage: /*#__PURE__*/_jsx(_Fragment, {
        children: fallbackPageName
      })
    };
  }, [eschref, fallbackPageName, pageUrlItem]);
  const handleClick = useCallback(() => {
    PageReturnLinkHelper.clear();
    if (onTrackClick && path) {
      onTrackClick({
        path
      });
    }
  }, [onTrackClick, path]);
  if (!path) {
    return null;
  }
  return /*#__PURE__*/_jsx(BackButton, {
    children: /*#__PURE__*/_jsx(HubSpotAppLink, {
      LinkComponentProps: {
        'aria-label': ariaLabel
      },
      LinkComponent: LinkComponent,
      linkType: "PAGE",
      linkTypeProps: {
        path
      },
      onTrackClick: handleClick,
      children: backMessage
    })
  });
}
export default PageReturnLink;